<input
  (keydown.enter)="search()"
  [formControl]="innerModel"
  [attr.placeholder]="props.placeholder || ''"
  [attr.data-id]="field.key"
  autocomplete="off"
  class="text-input"
/>
